<div
  class="dropdown global-transition"
  (click)="dropdownMenu()"
  [ngClass]="{'dropdown-active': dropdownActive, 'button-select': isButtonSelect}"
  appClickOutsideComponent
  (clickOutside)="close()">
  <button
    [ngClass]="{'error-field': isInvalid || validationError, 'valid-field': isValid}"
    type="button"
    class="btn overflow-hidden select-button"
    [style.borderRadius.px]="borderRadius"
    [style.borderWidth.px]="borderWidth">
    <div class="d-flex align-items-start justify-content-between flex-column h-100 w-100">
      <div class="select-title text-left me-3" *ngIf="title">
        {{ 'view_translations.' + title | translate | uppercase }}
        <div
          *ngIf="tooltipText"
          class="tooltip-container tool-tip"
          ngbTooltip="{{ 'view_translations.' + tooltipText | translate }}"
          container="body"
          placement="top-right"
          tooltipClass="my-configurations-tooltip">
          <nb-icon icon="info" pack="icomoon"></nb-icon>
        </div>
      </div>
      <div *ngIf="placeholder && isEmpty" class="select-placeholder" [style.fontSize.px]="fontSize">{{ placeholder | t }}</div>
      <div *ngIf="!isEmpty" class="choosen-value" [style.fontSize.px]="fontSize">
        {{ shouldTranslate ? ('view_translations.' + choosenValue?.name | translate ) : choosenValue?.name }}
      </div>
    </div>
    <div>
      <nb-icon *ngIf="isInvalid || validationError" icon="cross-circle" pack="icomoon" class="invalid-icon"></nb-icon>
      <!-- <nb-icon *ngIf="isValid" icon="check" pack="icomoon" class="valid-icon"></nb-icon> -->
      <nb-icon icon="chevron-down" pack="icomoon" [ngClass]="{'active' : dropdownActive}" class="chevron-icon global-transition"></nb-icon>
    </div>
  </button>
  <ul class="dropdown-content">
    <li
      *ngFor="let element of data"
      class="dropdown-item global-transition"
      [ngClass]="{'active' : choosenValue?.name === element.name }"
      (click)="getValue(element)">
      <p>{{ shouldTranslate ? ( 'view_translations.' + element?.name | translate ): element?.name}}</p>
    </li>
  </ul>
  <div class="error-text" [ngClass]="{'error-text-small' : validationError}" id="errorTextContainer" *ngIf="isInvalid || validationError">
    <small class="form-text text-danger">{{ 'view_translations.this_field_is_required' | translate }}</small>
  </div>
</div>
